import { Box, styled } from '@mui/material';
import { IPublicAndPrivateSettings } from '@pepperhq/location-sdk';

import { MuiCardForm } from 'lib/form/MuiCardForm';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { SettingDisplay } from 'lib/SettingDisplay';
import { KeyValueSettings } from '../KeyValueSettings';
import { SettingDisplayText } from '../SettingDisplayText';
import { KeyValuePair } from '../hooks/useRecordSetting';

const PREFIX = 'TwilioSettings';

const classes = {
    settingsCard: `${PREFIX}-settingsCard`,
    displayClassName: `${PREFIX}-displayClassName`
};

const StyledMuiCardForm = styled(MuiCardForm)(({ theme }) => ({
    [`&.${classes.settingsCard}`]: {
        marginBottom: theme.spacing(2)
    },
    [`& .${classes.displayClassName}`]: {
        padding: theme.spacing(2)
    }
}));

type IProps = {
    settings: IPublicAndPrivateSettings;
    values: KeyValuePair[];
    onChange: (values: KeyValuePair[]) => void;
    onSubmit: (values: Record<string, any>) => Promise<boolean>;
};

export const TwilioSettingsCard = ({ settings, values, onChange, onSubmit }: IProps) => (
    <StyledMuiCardForm
        title="Twilio"
        initialValues={{
            accountSID: settings?.twilio?.accountSID,
            number: settings?.twilio?.number,
            authToken: settings?.twilio?.authToken
        }}
        childrenWhileDisplaying={
            <Box display="flex" flexDirection="column">
                <SettingDisplayText title="Account SID Identifier" text={settings?.twilio?.accountSID} />
                <SettingDisplayText title="Number" text={settings?.twilio?.number} />
                <SettingDisplayText title="Auth Token" text={settings?.twilio?.authToken} />
                <SettingDisplayText
                    title="Localised Numbers"
                    text={`${Object.keys(settings?.twilio?.numbers ?? {}).length} numbers`}
                />
            </Box>
        }
        childrenWhileEditing={
            <Box display="flex" flexDirection="column">
                <SettingDisplay label="Account SID">
                    <TextFormField name="accountSID" />
                </SettingDisplay>
                <SettingDisplay label="Number">
                    <TextFormField name="number" />
                </SettingDisplay>
                <SettingDisplay label="Auth Token">
                    <TextFormField name="authToken" />
                </SettingDisplay>
                <SettingDisplay label="Localised Numbers">
                    <KeyValueSettings
                        value={values}
                        keyPlaceholder="Phone Number"
                        valuePlaceholder="Valid Countries (e.g. GB, US)"
                        onChange={onChange}
                    />
                </SettingDisplay>
            </Box>
        }
        onSubmit={onSubmit}
        className={classes.settingsCard}
        boxClassName={classes.displayClassName}
    />
);
